<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.status"
    item-text="text"
    item-value="value"
    label="Status"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.status)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      { text: 'Active', value: 'active' },
      { text: 'Archived', value: 'archived' },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  mounted() {
    if (this.filterDatas.isrouteNewPage == false) {
      this.selectStatus = this.filterDatas.status;
      this.$emit('input', this.filterDatas.status);
    }
  },
  methods: {
    emitInput(data) {
      if (this.filterDatas.isrouteNewPage == false) {
        this.$store.commit('UPDATE_STATUS_FILTER', data);
        this.$emit('input', this.filterDatas.status);
      } else {
        this.$emit('input', data);
      }
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    // this.$emit("input", this.filterDatas.status);
  },
};
</script>
